import type { WindowSpec } from '@futrli-sdk/predict';

export interface ForecastWithWindowSpec {
  kind: 'live' | 'budget' | 'scenario';
  include_unpaid_invoices?: boolean;
  window_spec: WindowSpec;
}

/**
 * Returns the forecast duration in years, including the compatibility calculation required for legacy fixed forecasts.
 */
export const getForecastDuration = (forecast: ForecastWithWindowSpec): number => {
  if (forecast.window_spec.kind === 'custom-years') {
    return forecast.window_spec.duration_years;
  }

  // Temporary workaround for legacy fixed forecasts whose API window is incorrectly returned as
  // `full-financial-years-with-actuals` instead of `custom-years`.
  if (
    forecast.kind === 'scenario' &&
    !forecast.include_unpaid_invoices &&
    forecast.window_spec.kind === 'full-financial-years-with-actuals'
  ) {
    const { actuals_financial_years: actualsYears, forecast_financial_years: forecastYears } = forecast.window_spec;

    if (typeof actualsYears === 'number' && typeof forecastYears === 'number') {
      return actualsYears + forecastYears + 1;
    }
  }

  return forecast.window_spec.forecast_financial_years;
};
